import React, { FC, useState, useEffect } from 'react';
import CrossMarkAlt from 'components/Icons/CrossMarkAlt';
import CrossMark from 'components/Icons/CrossMark';
import Button from 'components/Button/Button';
import Caret from 'components/Icons/Caret';
import Filters from 'components/Icons/Filters';
import Plus from 'components/Icons/Plus';
import Minus from 'components/Icons/Minus';
import Search from 'components/Icons/Search';
import { useRouter } from 'next/router';


export interface CLFilterProps {
  isMobileFilterEnabled: any;
  populatedAttributes: any;
  activePanel: string;
  maxP: any;
  minP: any;
  minPlaceholderPrice: any;
  maxPlaceholderPrice: any;
  selectedPriceFilters: Array<any>;
  setSelectedFilters: (value: any) => void;
  setSelectedPriceFilters: (value: any) => void;
  setFirstEntryPoint: (value: any) => void;
  setMaxPrice: (value: string) => void;
  setMinPrice: (value: string) => void;
  setSelectedSort: (value: any) => void;
  setActivePanel: (value: any) => void;
  setSearchValue: (value: any) => void;
  setIsMobileFilterEnabled: (value:boolean|any) => void;
  handleCustomPriceFilter: (value: any) => void;
  populatedNames: any;
  firstEntryPoint: string;
  focusInputField: (value: any) => void;
  selectedFilterLength: string;
  searchValue: string;
  handleSearchChange: (value: any) => void;
  sortBy: any;
  handleMobileFilter: () => void;
  cTable: any;
  selectedSort: number;
  priceRange: any;
  bundleFilter: Boolean;
  setBundleFilter: (value: any) => void;
  // Additional props like colour etc.
  [x: string]: any;
}

const CLFilter: FC<CLFilterProps> = ({
  emptySelectedFilter,
  isMobileFilterEnabled,
  populatedAttributes,
  activePanel,
  setSelectedFilters,
  setFirstEntryPoint,
  setMaxPrice,
  setMinPrice,
  setSelectedPriceFilters,
  handleCustomPriceFilter,
  setActivePanel,
  selectedFilters,
  selectedPriceFilters,
  firstEntryPoint,
  populatedNames,
  selectedFilterLength,
  minP,
  minPrice,
  maxPrice,
  maxP,
  focusInputField,
  searchValue,
  setSearchValue,
  handleMobileFilter,
  handleSearchChange,
  minPlaceholderPrice,
  maxPlaceholderPrice, 
  setIsMobileFilterEnabled, 
  sortBy,
  priceRange,
  cTable,
  selectedSort,
  setSelectedSort,
  bundleFilter,
  setBundleFilter
}) => {
  const filterAttr: any = {
    "pa_contact-lens-brand":"Brand",
    "pa_contact-lens-manufacturer":"Manufacturer",
    "pa_frequency":"Frequency",
    "pa_pack-size":"Pack Size",
    "pa_contact-lens-type":"Lens Type",
  }

  
  const router = useRouter()
  const [isLoaded, setIsLoaded] = useState(false);
  const [componentKey, setComponentKey] = useState(1);
  const [activeCrossmark, setActiveCrossmark] = useState<any>(null);

  const getOtherParams = (limiter:string) => {
      let url = limiter || '?';
      const otherParams = Object.keys(router.query)
    .filter((item) => item != 'manufacturer')
    .filter((item) => item != 'colour')
    .filter((item) => item != 'pack_size')
    .filter((item) => item != 'type')
    .filter((item) => item != 'frequency')
    .filter((item) => item != 'brand')
    //.filter((item) => item != 'bundle')

    otherParams.map((item) => {
      if(url.length != 1) url += '&'
      url+=item+'='+router.query[item]
    })
    
    return url.length == 1 ? '' : url
  }

  const getQueryString = (selectedFilters:any) => {
    const brands = [...selectedFilters['pa_contact-lens-brand']].join('|')
    const frequencies = [...selectedFilters['pa_frequency']].join('|')
    const typ = [...selectedFilters['pa_contact-lens-type']].join('|')
    const size = [...selectedFilters['pa_pack-size']].join('|')
    const manufacturer = [...selectedFilters['pa_contact-lens-manufacturer']].join('|')
    const colour = [...selectedFilters['pa_contact-lens-colour']].join('|')
    
    let qs = '?';

    if(brands) qs += 'brand='+brands
    if(frequencies) {
      if(qs.length != 1) qs += '&'
      qs += 'frequency='+frequencies
    }
    if(typ){
      if(qs.length != 1) qs += '&'
      qs += 'type='+typ
    } 
    if(size){
      if(qs.length != 1) qs += '&'
      qs += 'pack_size='+size
    }
    if(colour){
      if(qs.length != 1) qs += '&'
      qs += 'colour='+colour
    }
    if(manufacturer){
      if(qs.length != 1) qs += '&'
      qs += 'manufacturer='+manufacturer
    }

    /*if(bundleFilter == true){
      if(qs.length != 1) qs += '&'
      qs += 'bundle=true'
    }*/

    return qs.length == 1 ? '' : qs
  }

  useEffect(() => {
    const data:any = Object.assign({}, {...emptySelectedFilter})
    if(router.query?.brand){
      const qs:any = router.query?.brand.indexOf('|') > -1 ? (router.query?.brand as string).split('|'):[router.query.brand]
      data['pa_contact-lens-brand'].push(...qs)
    }

    if(router.query?.type){
      const qs:any = router.query?.type.indexOf('|') > -1 ? (router.query?.type as string).split('|'):[router.query.type]
      data['pa_contact-lens-type'].push(...qs)
    }

    if(router.query?.frequency){
      const qs:any = router.query?.frequency.indexOf('|') > -1 ? (router.query?.frequency as string).split('|'):[router.query.frequency]
      data['pa_frequency'].push(...qs)
    }

    if(router.query?.manufacturer){
      const qs:any = router.query?.manufacturer.indexOf('|') > -1 ? (router.query?.manufacturer as string).split('|'):[router.query.manufacturer]
      data['pa_contact-lens-manufacturer'].push(...qs)
    }

    if(router.query?.colour){
      const qs:any = router.query?.colour.indexOf('|') > -1 ? (router.query?.colour as string).split('|'):[router.query.colour]
      data['pa_contact-lens-colour'].push(...qs)
    }

    if(router.query?.pack_size){
      const qs:any = router.query?.pack_size.indexOf('|') > -1 ? (router.query?.pack_size as string).split('|'):[router.query.pack_size]
      data['pa_pack-size'].push(...qs)
    }
    if(router.query?.bundle ){
      setBundleFilter(true)
    }

    if(isLoaded == false){
      setIsLoaded(true);
      setSelectedFilters(data)
      
    }
    setComponentKey(componentKey+1)
    
  }, [router.query, bundleFilter]);

  
  useEffect(() => {
    const urlTypes:any = {
      "pa_contact-lens-brand":"brand",
      "pa_frequency":"frequency",
      "pa_contact-lens-type":"type"
    }
    const filterType = Object.keys(selectedFilters).filter((item) => selectedFilters[item].length > 0).filter((item) => (item == 'pa_contact-lens-brand' || item == 'pa_frequency' || item == 'pa_contact-lens-type' ))[0];
      if((Object.keys(selectedFilters).map((item:any) => selectedFilters[item].length).reduce((a, b) => a + b) == 1) && filterType){
        if(!(router.query.brand || router.query.frequency || router.query.type)){
          router.replace('/shop/contact-lenses/'+urlTypes[filterType]+'/'+selectedFilters[filterType][0]+getOtherParams('?'));
        }
      }else{
        const qs = getQueryString(selectedFilters)
        if(parseInt(selectedFilterLength) > 0 && bundleFilter == true){
          router.replace('/shop/contact-lenses' + qs + '' + getOtherParams(qs.length > 0 ?'&':'?'))
        }
        
        //router.replace('/shop/contact-lenses/'+ getQueryString(selectedFilters) + getOtherParams())
      }
  },[selectedFilters, bundleFilter])

  return (
    <div className="text-brand-black100" key={componentKey}>
        <div>
          {populatedAttributes["pa_contact-lens-brand"].map((item:any) => router.query?.brand != item && <a className="seo-hidden-link" title={populatedNames[item]+" Contact Lenses"} href={`/shop/contact-lenses/brand/${item}`} key={item}>{populatedNames[item]} Contact Lenses</a>)}
          {populatedAttributes["pa_contact-lens-type"].map((item:any) => router.query?.type != item && <a className="seo-hidden-link" title={populatedNames[item]+" Contact Lenses"} href={`/shop/contact-lenses/type/${item}`} key={item}>{populatedNames[item]} Contact Lenses</a>)}
          {populatedAttributes["pa_frequency"].map((item:any) => router.query?.frequency != item && <a className="seo-hidden-link" title={populatedNames[item]+" Contact Lenses"} href={`/shop/contact-lenses/frequency/${item}`} key={item}>{populatedNames[item]} Contact Lenses</a>)}
        </div>
        <div className="flex lg:relative">
          <div className='flex items-center text-base font-medium text-brand-black100 m-4 ml-0 h-10 leading-10 lg:hidden' onClick={handleMobileFilter}><span className='relative font-normal mr-2 -top-0.5'>Filter {(parseInt(selectedFilterLength)+selectedPriceFilters.length) > 0 && '('+(parseInt(selectedFilterLength)+selectedPriceFilters.length)+')'}</span> <Filters/></div>
          <div className={`flex ${isMobileFilterEnabled ? 'fixed top-0 left-0 w-full h-full z-50 bg-white flex-col overflow-auto': 'lgx:hidden relative'}`}>
          {isMobileFilterEnabled && <div className='flex justify-between m-3 items-center font-medium'>Filters <CrossMark onClick={() => {setIsMobileFilterEnabled(false)}}/></div>}
          {isMobileFilterEnabled && <div className='flex m-3 justify-between items-center font-medium order-10'><Button variant='default' className='border border-brand-grey75 mr-2' onClick={() => {
            setSelectedFilters(emptySelectedFilter);
            setSelectedPriceFilters([])
            setFirstEntryPoint(null)
            setMaxPrice('');
            setMinPrice('');
            setComponentKey(componentKey+1)
          }}>Clear All</Button> <Button className="bg-black text-white flex-1" onClick={() => {setIsMobileFilterEnabled(false)}}>Apply</Button></div>}
          {Object.keys(populatedAttributes).map((item, idx) => {
            return (
              (item != 'countTable' && item != "pa_bundle-box-count" && filterAttr[item]) &&
              <div key={idx} className={`relative cursor-pointer lgx:order-1 text-brand-grey300 lgx:m-3 lg:m-4 lg:ml-0 lg:h-10 ${activePanel == item ? 'text-brand-orange lg:border-b-2 lg:border-brand-orange' : ' '}`} 
              onMouseLeave={() => !isMobileFilterEnabled && setActivePanel(null)}
              onMouseOver={() => {!isMobileFilterEnabled && setActivePanel(item)}}>
                <span className='lg:leading-10 lgx:flex lgx:justify-between lgx:items-center' 
                  onClick={() =>{
                    if(isMobileFilterEnabled && item == activePanel) return setActivePanel(null)
                      setActivePanel(item)
                    }}>
                  {filterAttr[item]} 
                  {isMobileFilterEnabled && activePanel != item && <Plus className='inline-block lg:hidden' />}
                  {isMobileFilterEnabled && activePanel == item && <Minus className='inline-block lg:hidden' />}
                  <Caret className={`inline-block lgx:hidden transition duration-150 ease-out hover:ease-in rotate-0 scale-90 ml-2 ${activePanel == item && 'rotate-180'}`} fill={`${activePanel !=  item ? '#2A2A2A':'#FF8200'}`} />
                </span>
                
                <ul className={`lg:absolute lgx:relative lg:top-10 z-20 max-w-80 text-sm bg-white p-4 rounded-sm text-brand-grey300 lg:drop-shadow-md ${activePanel == item ? '' : 'hidden'}`}>
                  {(item == 'pa_pack-size' && (router.locale === 'ca')) && <li className={`flex items-center hover:text-brand-orange leading-5`}><input className={`dresden-checkbox relative m-2 w-4 h-4 rounded border-brand-grey400`} type="checkbox" id="bundle" checked={bundleFilter===true} onChange={() => {
                    if(bundleFilter) {
                      router.replace('/shop/contact-lenses');  
                    }
                    setBundleFilter(!bundleFilter)
                    setSelectedFilters(selectedFilters)
                    setComponentKey(componentKey+1)
                  }}/> <label htmlFor='bundle' className='whitespace-nowrap text-brand-blue font-medium mr-2'>Bundle discount packs</label></li>}
                  {[...new Set(populatedAttributes?.[item])].sort((a: any, b: any) => a.localeCompare(b)).sort((a: any ,b: any) => {
                    const keyA = parseInt(a);
                    const keyB = parseInt(b);
                    if (keyA >= keyB) return 1;
                    if (keyA < keyB) return -1;
                    return 0;
                  }).map((i: any, v: number) => {
                    return ( selectedFilters[item] && 
                      <li className={`flex items-center hover:text-brand-orange leading-5 ${(((item != firstEntryPoint) && (Object.keys(router.query).length != 0) || (selectedPriceFilters.length > 0) ||bundleFilter == true) && (!populatedAttributes.countTable?.[i] || !cTable?.[i])) && 'text-brand-grey opacity-50' }`} key={componentKey+"_"+v}>
                        <input className={`dresden-checkbox relative m-2 w-4 h-4 rounded border-brand-grey400`} style={{ accentColor: 'hsl(31, 100%, 50%)' }} type="checkbox" id={`filter_${i}`} disabled={(((item != firstEntryPoint) || (selectedPriceFilters.length > 0)) && (!cTable?.[i] || !populatedAttributes.countTable?.[i]))} checked={selectedFilters[item].find((e: string) => e === i)} onChange={() => {
                        let state:any;
                        if (selectedFilters[item].find((e: any) => e === i)) {
                          state = Object.assign({ ...selectedFilters }, {
                            [item]: selectedFilters[item].filter(function (value: any, index: any, arr: any) {
                              return value !== i;
                            })
                          })
                        } else {
                          state = Object.assign({ ...selectedFilters }, { [item]: [...selectedFilters[item], i] })
                        }

                        if(!firstEntryPoint && parseInt(selectedFilterLength) == 0){
                          setFirstEntryPoint(item)
                        }
                        
                        setSelectedFilters(state)
                        setComponentKey(componentKey+1)
                      }} /><label className="w-fit mr-5 whitespace-nowrap" htmlFor={`filter_${i}`}><div className="w-fit">{`${populatedNames?.[i] || i} ${item == 'pa_pack-size' ? ' Lenses' : ''}`} ({((item != firstEntryPoint) && ((selectedPriceFilters.length == 0 && parseInt(selectedFilterLength) == 0) && bundleFilter!=true)? populatedAttributes.countTable?.[i]: cTable?.[i] ) || '0'})</div></label></li>
                    )
                  })}
                </ul>
              </div>)  
          })}
            <div className={`relative text-brand-grey300 lgx:m-3 m-4 lgx:order-1 lg:ml-0 lg:h-10 ${activePanel == 'price' ? 'text-brand-orange lg:border-b-2 lg:border-brand-orange' : ' '}`} 
                  onMouseOver={() => {!isMobileFilterEnabled && setActivePanel('price')}} 
                  onMouseLeave={() => !isMobileFilterEnabled && setActivePanel(null)}>  
                <div className={`lg:leading-10 cursor-pointer lgx:flex lgx:justify-between lgx:items-center`} onClick={() =>{
                    if(isMobileFilterEnabled && activePanel == 'price') return setActivePanel(null)
                    setActivePanel('price')}} >Price
                  {isMobileFilterEnabled && activePanel != 'price' && <Plus className='inline-block lg:hidden' />}
                  {isMobileFilterEnabled && activePanel == 'price' && <Minus className='inline-block lg:hidden' />} 
                  <Caret className={`lgx:hidden inline-block scale-90 ml-2 ${activePanel == 'price' && 'rotate-180'}`} fill={`${activePanel !=  'price' ? '#2A2A2A':'#FF8200'}`} /> 
                </div>
                <ul className={`lg:absolute lgx:relative lg:top-10 z-20 max-w-80 text-sm bg-white p-4 text-brand-grey300 lg:drop-shadow-md ${activePanel == 'price' ? '' : 'hidden'}`}>
                  <li className={`flex w-auto items-center leading-5`}>
                    <input ref={minP} type="text" style={{textIndent:5}} className="m-1 h-8 w-[76px] rounded-md appearance-none border border-brand-grey400 focus:outline-none" defaultValue={minPrice} placeholder={(minPlaceholderPrice == Infinity ? 0 : minPlaceholderPrice)+'$'}/>
                    <input ref={maxP} type="text" style={{textIndent:5}} className="m-1 h-8 w-[76px] rounded-md border border-brand-grey400 focus:outline-none ml-1 indent-1" defaultValue={maxPrice} placeholder={(maxPlaceholderPrice == -Infinity ? 0 : maxPlaceholderPrice)+'$'}/>
                    <a onClick={handleCustomPriceFilter}>
                      <Button className="hover:bg-brand-orange bg-brand-black50 w-8 h-8 ml-1 rounded flex justify-center" variant='text' icon={<Search fill="white"/>}></Button>
                    </a>
                  </li>
                  {priceRange.map((item:any, idx:number) => <li className={`flex w-auto items-center leading-5 hover:text-brand-orange`} key={idx}>
                          <input className={`dresden-radio relative m-2 w-4 h-4 rounded`} type="checkbox" id={`filter_${item.option}`} checked={selectedPriceFilters.find((e:any) => e.option === item.option)} onChange={() => {
                        
                          if (selectedPriceFilters.find((e: any) => e.val[0] === item.val[0])) {
                            setSelectedPriceFilters([...selectedPriceFilters.filter((e:any, idx:number) => e.val[0] !== item.val[0])])
                          }else{
                            const state:any = [item];
                            setSelectedPriceFilters(state)
                          }
                          setComponentKey(componentKey+1)
                          
                        }} /><label className="mr-5 whitespace-nowrap" htmlFor={`filter_${item.option}`}><div className="w-fit">{`${item.option}`}</div></label></li>)}
                </ul>
            </div>
            <div className="relative lgx:w-full lg:m-4 lgx:p-4 self-center">
              <input type="text" style={{textIndent:8}} 
                className=" lg:w-32 lgx:w-full max-h-8 focus:outline-none rounded-md leading-8 border text-sm border-brand-grey400" 
                placeholder="Search" 
                ref={focusInputField}
                value={searchValue}
                onChange={handleSearchChange} 
                />
                <span className="absolute lg:top-2.5 lg:right-2 lgx:right-6 lgx:top-6">
                  {searchValue.length == 0 && <Search  />}
                  {searchValue.length > 0 && <CrossMarkAlt className='w-3' onClick={() => setSearchValue('')} />}
                </span>
              </div>
            
          </div>
          
          
          <div className={`absolute right-0 text-brand-grey450 m-4 ml-0 h-10 ${activePanel == 'sort' ? 'text-brand-orange border-b-2 border-brand-orange' : ' '}`} onClick={() =>{setActivePanel('sort')}} onMouseLeave={() => setActivePanel(null)}>  
              <div className={`leading-10 text-brad-grey450 `} >Sort By: <span className="text-brand-orange">{sortBy[selectedSort].name} <Caret className={`inline-block scale-90 ml-2 ${activePanel == 'sort' && 'rotate-180'}`} fill={`${activePanel !=  'sort' ? '#2A2A2A':'#FF8200'}`} /></span> </div>
              <ul className={`absolute top-10 r-0 z-20 w-full content bg-white p-4 text-sm font-normal rounded-sm text-brand-grey300 drop-shadow-md ${activePanel == 'sort' ? '' : 'hidden'}`}>
                {sortBy.map((item:any, idx:number) => <li key={idx} className="mt-1 cursor-pointer hover:text-brand-orange"><a onClick={() => setSelectedSort(idx)}>{item.name}</a></li>)}
              </ul>
          </div>
        </div>
        <div className="flex flex-wrap">
          {Object.keys(selectedFilters).map((item, index) => {
            return (<React.Fragment key={index}>
              {selectedFilters[item].map((filterItem: any, idx: number) => <div key={idx} className="m-1 mr-[10px] ml-0 group rounded-[0.4rem] h-10 border border-brand-grey150 leading-9 pl-2 pr-2 text-sm cursor-pointer" onClick={() => {
                const state = Object.assign({ ...selectedFilters }, {
                  [item]: selectedFilters[item].filter(function (value: any, index: any, arr: any) {
                    return value !== filterItem;
                  })
                })
                
                setSelectedFilters(state)
                setComponentKey(componentKey+1)
              }} 
              onMouseEnter={() => setActiveCrossmark(filterItem)}
              onMouseLeave={() => setActiveCrossmark(null)} >{`${populatedNames[filterItem] || filterItem} ${item == 'pa_pack-size' ? 'Lenses': ''}`}<CrossMarkAlt fill={`${activeCrossmark == filterItem ? "#ff8200": "#2A2A2A"}`} className='inline w-3 top-[-1px] relative ml-1'/></div>)}
            </React.Fragment>
            )
          })}
          {selectedPriceFilters.map((filterItem: any, idx: number) => <div key={idx} className="m-1 mr-[10px] ml-0 rounded-[0.4rem] h-10 border border-brand-grey150 leading-9 pl-2 pr-2 text-sm cursor-pointer" onClick={() => {
            setSelectedPriceFilters([])
            setMaxPrice('');
            setMinPrice('');
            setComponentKey(componentKey+1)
          }} 
          onMouseEnter={() => setActiveCrossmark(filterItem)}
          onMouseLeave={() => setActiveCrossmark(null)}>{`${filterItem.option}`}<CrossMarkAlt fill={`${activeCrossmark == filterItem ? "#ff8200": "#2A2A2A"}`} className='inline w-3 top-[-1px] relative ml-1'/></div>)}
          {parseInt(selectedFilterLength)+selectedPriceFilters.length > 1 && <div className="m-1 mr-[10px] ml-0 rounded-[0.4rem] h-10 border text-brand-blue25 hover:text-brand-orange border-brand-grey150 leading-9 pl-2 pr-2 text-sm cursor-pointer" 
              onClick={() => {
                setSelectedFilters(emptySelectedFilter);
                setSelectedPriceFilters([])
                setFirstEntryPoint(null)
                setMaxPrice('');
                setMinPrice('');
                setComponentKey(componentKey+1)
                setBundleFilter(false)
                
                router.replace('/shop/contact-lenses')
              }}
              onMouseEnter={() => setActiveCrossmark("Clear")}
              onMouseLeave={() => setActiveCrossmark(null)}>
            Clear all <CrossMarkAlt  fill={`${activeCrossmark == "Clear" ? "#ff8200": "#00AEC7"}`} className='inline w-3 top-[-1px] relative ml-1' />
          </div>}
        </div>
      </div>
  );
};

export default CLFilter;
